import React from 'react';
import SvgDefaultArrowRight from '../svg/icons/default-arrow-right.svg';

export default function EventStatus({ status, statusValue, ticketUrl, ticket, theme }) {
  if (status && statusValue !== 'hidden') {
    if (['online', 'ticketsExternal', 'register', 'waitingList', 'info'].includes(statusValue) && ticketUrl) {
      return (
        <a href={ticketUrl} title={status} className="link link--icon-before " data-theme={theme} data-row="xxs">
          <SvgDefaultArrowRight />
          <div className="text text--link">{status}</div>
        </a>
      );
    }

    return (
      <p className="text text--meta">
        <b>/</b> {status}
      </p>
    );
  }

  if (ticket && ticket.href && ticket.label) {
    return (
      <a className="button button--primary" href={ticket.href} title={ticket.label} target="_blank" rel="noopener noreferrer" data-theme={theme}>
        <span>{ticket.label}</span>
      </a>
    );
  }

  return null;
}
